// extracted by mini-css-extract-plugin
export var bold = "_yw-0";